import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import HomePage from './pages/HomePage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Auth from './utils/Auth';
import { AuthProvider } from './context/AuthContext';
import Page404 from './pages/common/404Page';
import LoginPage from './pages/auth/LoginPage';
import GroupsPage from './pages/manage/GroupsPage';
import { ToastContainer } from 'react-toastify';
import CrudManagerExample from './utils/Crud-Manager/Example';
import DrawsPage from './pages/manage/DrawsPage';
import PersonalInfoPage from './pages/settings/PersonalInfoPage';
import SubscriptionPage from './pages/manage/SubscriptionPage';
import Documents from './pages/support/Documents';
import Faq from './pages/support/Faq';
import TestPage from './utils/TestPage';
import SeedData from './utils/SeedData';

import RolesPage from './pages/settings/RolesPage';
import UsersPage from './pages/settings/UsersPage';
import WinnerPage from './pages/manage/WinnerPage';
import InvestmentPage from './pages/manage/InvestmentPage';
import Footer from './components/Footer';
import PaymentGateWayPage from './pages/Accounting/PaymentGateWayPage';
import SmsServicePage from './pages/settings/SmsServicePage';
import HomeAlert from './pages/settings/HomeAlert';
import TransactionPage from './pages/Accounting/TransactionPage';
import AccountPage from './pages/Accounting/AccountPage';
import CustomerQueries from './pages/support/CustomerQueries';
import HolidayPage from './pages/settings/HolidayPage';
import AppEnv from './pages/settings/AppEnv';
import ScreenShot from './pages/support/ScreenShot';
import Settlement from './pages/support/Settlement';
import CSVMigratorPage from './pages/CSVMigratorPage';
import MigrationLogsPage from './pages/MigrationLogsPage';
import CSVDemigratorPage from './pages/CSVDemigratorPage';
import CSVVerifierPage from './pages/CSVVerifierPage';
import RecentChangesPage from './pages/RecentChangesPage';
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Auth component={<HomePage />} />} exact />


            {/* Auth Routes */}
            <Route path="/login" element={<Auth component={<LoginPage />} />} exact />
            <Route path="/appenv" element={<Auth component={<AppEnv />} />} exact />
            {/* Manage App Routes */}
            <Route path="/group" element={<Auth component={<GroupsPage />} />} exact />
            <Route path="/subscription" element={<Auth component={<SubscriptionPage />} />} exact />
            <Route path="/investment" element={<Auth component={<InvestmentPage/>} />} exact />
            <Route path="/draw" element={<Auth component={<DrawsPage />} />} exact />
            <Route path="/winner" element={<Auth component={<WinnerPage />} />} exact />
                   {/* Accounting Routes */}
             <Route path="/account" element={<Auth component={<AccountPage />} />} exact />
            <Route path="/transaction" element={<Auth component={<TransactionPage />} />} exact />
            <Route path="/paymentgateway" element={<Auth component={<PaymentGateWayPage />} />} exact />


               {/* Setting Routes */}
            <Route path="/users" element={<Auth component={<UsersPage/>} />} exact />
            {/* <Route path="/status" element={<Auth component={<StatusPage />} />} exact /> */}
            <Route path="/role" element={<Auth component={<RolesPage/>} />} exact />
            <Route path="/personalinfo" element={<Auth component={<PersonalInfoPage />} />} exact />
            <Route path="/sms" element={<Auth component={<SmsServicePage />} />} exact />
            <Route path="/homealert" element={<Auth component={<HomeAlert />} />} exact />
            <Route path="/holiday" element={<Auth component={<HolidayPage />} />} exact />
            

            {/* Support Routes */}
            <Route path="/documents" element={<Auth component={<Documents />} />} exact />
            <Route path="/faq" element={<Auth component={<Faq />} />} exact />
            <Route path="/customer-queries" element={<Auth component={<CustomerQueries />} />} exact />
            <Route path="/screenshot" element={<Auth component={<ScreenShot />} />} exact />
            <Route path="/settlement" element={<Auth component={<Settlement />} />} exact />
            <Route path="/csv-migrator" element={<Auth component={<CSVMigratorPage />} />} exact />
            <Route path="/migration-logs" element={<Auth component={<MigrationLogsPage />} />} exact />
            <Route path="/csv-demigrator" element={<Auth component={<CSVDemigratorPage />} />} exact />
            <Route path="/csv-verifier" element={<Auth component={<CSVVerifierPage />} />} exact />
            <Route path="/recent-changes" element={<Auth component={<RecentChangesPage />} />} exact />

            {/* Common Routes */}
            <Route path="/example" element={<CrudManagerExample />}  exact />
            <Route path="*" element={<Page404  />} />
            {/* Test Routes */}
       
            <Route path="/test" element={<TestPage  />} />
            <Route path="/seed" element={<SeedData  />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Footer />
    </div>
  );
}
export default App;
